module.exports = __webpack_public_path__ + "img/robo-klaus.5ef11332.svg";